import type { ValidationError } from './types'
import type { Datenweitergabe, DatenUebertragungsZiel } from '@/types/studyTypes'

export function validateZiel(ziel: DatenUebertragungsZiel, index: number): ValidationError[] {
  const errors: ValidationError[] = []

  {
    if (!ziel.empfaenger?.trim())
      errors.push({
        field: `datenUebertragung.${index}.empfaenger`,
        message: 'Empfänger ist ein Pflichtfeld.',
      })

    if (!ziel.partnerDatenArt?.length)
      errors.push({
        field: `datenUebertragung.${index}.partnerDatenArt`,
        message: 'Bitte Datenart angeben.',
      })

    if (
      ziel.partnerDatenArt?.includes('anonymisiert') &&
      !ziel.partnerDatenArtAnonymisiertText?.trim()
    )
      errors.push({
        field: `datenUebertragung.${index}.partnerDatenArtAnonymisiertText`,
        message: 'Beschreibung der Anonymisierung ist erforderlich.',
      })

    if (ziel.partnerDatenArt?.includes('idat') && !ziel.partnerDatenArtIdatText?.trim())
      errors.push({
        field: `datenUebertragung.${index}.partnerDatenArtIdatText`,
        message: 'Beschreibung der IDAT ist erforderlich.',
      })

    if (!ziel.uebertragungsArt?.length)
      errors.push({
        field: `datenUebertragung.${index}.uebertragungsArt`,
        message: 'Bitte Übertragungsart angeben.',
      })

    if (ziel.uebertragungsArt?.includes('web') && !ziel.uebertragungsArtWebText?.trim())
      errors.push({
        field: `datenUebertragung.${index}.uebertragungsArtWebText`,
        message: 'Web-Applikation ist ein Pflichtfeld.',
      })

    if (ziel.uebertragungsArt?.includes('cloud') && !ziel.uebertragungsArtCloudText?.trim())
      errors.push({
        field: `datenUebertragung.${index}.uebertragungsArtCloudText`,
        message: 'Cloud-Applikation ist ein Pflichtfeld.',
      })

    if (ziel.uebertragungsArt?.includes('sonstige') && !ziel.uebertragungsArtSonstige?.trim())
      errors.push({
        field: `datenUebertragung.${index}.uebertragungsArtSonstige`,
        message: 'Beschreibung sonstiger Übertragung ist erforderlich.',
      })

    if (ziel.partnerInternExtern === 'intern' && !ziel.partnerInternZiel)
      errors.push({
        field: `datenUebertragung.${index}.partnerInternZiel`,
        message: 'Bitte internes Ziel angeben.',
      })

    if (ziel.partnerInternExtern === 'extern' && !ziel.partnerExternRegion)
      errors.push({
        field: `datenUebertragung.${index}.partnerExternRegion`,
        message: 'Bitte Region des externen Partners angeben.',
      })

    if (ziel.partnerInternExtern === 'extern') {
      if (ziel.datenweitergabeVertraglichGeregelt === undefined)
        errors.push({
          field: `datenUebertragung.${index}.datenweitergabeVertraglichGeregelt`,
          message: 'Bitte angeben, ob die Datenweitergabe vertraglich geregelt ist.',
        })

      if (
        ziel.datenweitergabeVertraglichGeregelt === false &&
        !ziel.datenweitergabeNichtVertraglichGeregeltGrund?.trim()
      )
        errors.push({
          field: `datenUebertragung.${index}.datenweitergabeNichtVertraglichGeregeltGrund`,
          message: 'Bitte begründen, warum die Datenweitergabe nicht vertraglich geregelt ist.',
        })

      if (
        ziel.verhaeltnisse?.includes('vertragGemeinsameVerantwortung') &&
        !ziel.gemeinsamVerantwortlicheVertragsNr?.trim()
      )
        errors.push({
          field: `datenUebertragung.${index}.gemeinsamVerantwortlicheVertragsNr`,
          message: 'Bitte Vertragsnummer für Gemeinsame Verantwortlichkeit angeben.',
        })

      if (
        ziel.verhaeltnisse?.includes('auftragsverarbeitung') &&
        !ziel.auftragsverarbeitungVertragsNr?.trim()
      )
        errors.push({
          field: `datenUebertragung.${index}.auftragsverarbeitungVertragsNr`,
          message: 'Bitte Vertragsnummer für Auftragsdatenverarbeitung angeben.',
        })

      if (ziel.verhaeltnisse?.includes('dta_mta') && !ziel.dta_mtaVertragsNr?.trim())
        errors.push({
          field: `datenUebertragung.${index}.dta_mtaVertragsNr`,
          message: 'Bitte Vertragsnummer für DTA/MTA angeben.',
        })

      if (ziel.verhaeltnisse?.includes('kooperationsvertrag') && !ziel.kooperationspartnerVertragsNr?.trim())
        errors.push({
          field: `datenUebertragung.${index}.kooperationspartnerVertragsNr`,
          message: 'Bitte Vertragsnummer für Kooperationsvertrag angeben.',
        })
    }
  }

  return errors
}

export function validateDatenweitergabe(d: Datenweitergabe): ValidationError[] {
  const errors: ValidationError[] = []

  // Only validate if datenweitergabe is active (datenUebertragung array exists)
  if (!d.datenUebertragung) return errors

  d.datenUebertragung.forEach((ziel, index) => {
    errors.push(...validateZiel(ziel, index))
  })

  if (d.datenUebertragung.length > 0 && !d.pseudonymlisteImHaus)
    errors.push({
      field: 'pseudonymlisteImHaus',
      message: 'Bitte eine Option zur Pseudonymliste wählen.',
    })

  if (
    d.pseudonymlisteImHaus === 'nein' &&
    !d.pseudonymListeAusserHausBegruendungUndEmpfaenger?.trim()
  )
    errors.push({
      field: 'pseudonymListeAusserHausBegruendungUndEmpfaenger',
      message: 'Begründung und Empfänger sind erforderlich.',
    })

  return errors
}
